'use client';

import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

import ColorModeContainer from '@/components/ColorModeContainer';

export interface Props {
  padding?: number | string;
  style?: React.CSSProperties;
  resizable?: boolean;
  layout?: boolean;
  children: React.ReactNode;
  // We may wish to switch the underlying styled element. Fortunately, Linaria supports 'as':
  as?: React.ElementType;
}

function OutputWrapper({
  padding = 32,
  style = {},
  resizable,
  children,
  layout = true,
  ...delegated
}: Props) {
  const formattedOutputPadding =
    typeof padding === 'number' ? `${padding}px` : padding;

  return (
    <ColorModeContainer colorMode="light">
      <Wrapper
        layout={layout}
        style={{
          '--padding': formattedOutputPadding,
          resize: resizable ? 'both' : undefined,
          overflow: resizable ? 'auto' : 'hidden',
          ...style,
        }}
        {...delegated}
      >
        {children}
      </Wrapper>
    </ColorModeContainer>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--padding);
  text-align: center;
  overflow: hidden;
  border-radius: 4px;
`;

export default OutputWrapper;
